// extracted by mini-css-extract-plugin
module.exports = {"machineContainer":"styles_machineContainer__1uzRI","machine":"styles_machine__1Ri-e"};